'use client';

import React from 'react';
import { Cookie } from 'lucide-react';
import LegalDocumentBody from '@/components/LegalDocumentBody';

export default function CookiePolicyContent() {
  return (
    <LegalDocumentBody
      pageId="cookie"
      icon={<Cookie size={13} className="text-primary" />}
      calloutIcon={<Cookie size={15} className="text-muted-foreground shrink-0 mt-0.5" />}
      footerLinks={[
        { href: '/privacy-policy', labelKey: 'privacyLink' },
        { href: '/terms-of-service', labelKey: 'termsLink' },
      ]}
    />
  );
}
